import { clickUpdator } from "../../common/api";
import EventDispatcher from "../../common/EventDispatcher";

export default class Privacy {
  constructor() {
    document
      .querySelector("#privacy_agree")
      .addEventListener("click", this.updatePrivacyStatus.bind(this, true));
    document
      .querySelector("#privacy_disagree")
      .addEventListener("click", this.updatePrivacyStatus.bind(this, false));
    document
      .querySelector("#privacy_notice #proceedBtn")
      .addEventListener("click", this.showNextScreen.bind(this, false));

    this.mainPrivacy = document.querySelector("#p-n-popup");
    this.privacyBack = document.querySelector("#privacyBack");

    this.mainPrivacy.addEventListener(
      "click",
      this.hideAllAndShowByID.bind(this, "privacy_scr")
    );
  }
  init() {
    this.privacyAgreed = true;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
      case "hide_screen":
        this.hideScreen(data["message"]["data"]);
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "Privacy") return false;

    document.querySelector("#privacy_notice").classList.add("active");
  }
  updatePrivacyStatus(privacyAgreed) {
    this.privacyAgreed = privacyAgreed;
    const proceedBtn = document.querySelector("#proceedBtn");
    if (this.privacyAgreed) {
      document.querySelector("#privacy_agree").classList.add("active");
      document.querySelector("#privacy_disagree").classList.remove("active");
      document.querySelector("#pn-err").classList.remove("show");
      proceedBtn.style.display = "flex";
    } else {
      document.querySelector("#privacy_agree").classList.remove("active");
      document.querySelector("#privacy_disagree").classList.add("active");
      document.querySelector("#pn-err").classList.add("show");
      proceedBtn.style.display = "none";
    }
  }
  async showNextScreen() {
    this.events.dispatchEvent({
      type: "SOUND_EVENTS",
      message: {
        event_type: "play_sound",
        data: {
          sndKey: "music",
        },
      },
    });

    document.querySelector("#loader").classList.add("active");
    // const res = await clickUpdator(false, "agree");
    document.querySelector("#loader").classList.remove("active");
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "AgeVerify",
        },
      },
    });
  }
  hideAllAndShowByID(menuID) {
    document.querySelector("#terms_scr").classList.remove("active");
    if (menuID != null) {
      document.querySelector(`#${menuID}`).classList.add("active");
    }
  }
  goBack(v) {
    v.stopImmediatePropagation();
    this.hideAllAndShowByID(null);
  }
  hideScreen() {
    document.querySelector("#privacy_notice").classList.remove("active");
  }
}
